//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "demotionconfig",
  data() {
    return {
      record: {},
      yesOrNoList:[],
    };
  },
  methods:{
     initSelect() {
      //初始化行项下拉框对应值
      let params = [];
      //初始化下拉框
      let yesOrNoArray = {
        showcode: "yesOrNoList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {'paras0':'YESORNO','paras1':'1'}
      };
      params.push(yesOrNoArray);
      this.initDropDown(this, params);
    },
    getDemotionList(){
      let url = "/demotion/getDemoionList";
      let params = {
            record: { 
            },
            flowsysid:'FLOW'
        }
        this.axios.post(url, params)
            .then(({ data }) => {
            if ("1" === data.code) {
                this.record = data.data.record
            } else {
                alert("error:" + data.msg);
            }
          })
            .catch(error => console.log(error));
    },
    saveDemotion(){//保存
      let url = "/demotion/saveDemotion";
      let params = {
            record: this.record,
            flowsysid:'FLOW'
        }
     this.axios.post(url, params)
            .then(({ data }) => {
            if ("1" === data.code) {
                this.tipDefault(this.$t('common.savesuccess'));
            } else {
                alert("error:" + data.msg);
            }
          })
            .catch(error => console.log(error));
    },
    checkHystrix(){
       let url = "/login/checkHystrix";
       let params = {
            code:"0"
        }
        this.axios.post(url, params)
            .then(({ data }) => {
            if ("1" === data.code) {
                this.tipDefault(data.msg);
            } else {
                alert("error:" + data.msg);
            }
        }).catch(error => console.log(error));
    },
    checkHystrix2(){
       let url = "/login/checkHystrix";
       let params = {
            code:"-1"
        }
        this.axios.post(url, params)
            .then(({ data }) => {
            if ("1" === data.code) {
                this.tipDefault(data.msg);
            } else {
                alert("error:" + data.msg);
            }
        }).catch(error => console.log(error));
    }
  },
   created() {
    this.initSelect();
    this.getDemotionList();
  }, 
};



// WEBPACK FOOTER //
// ./src/pcpage/system/config/demotionconfig.vue